import { getAppScale } from "./appScale";

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function readFrameBox() {
  const frame = document.querySelector(".custom-pattern");
  if (!frame) return { left: 0, top: 0, width: 0, height: 0, scale: 1 };
  const rect = frame.getBoundingClientRect();
  return {
    left: rect.left,
    top: rect.top,
    width: rect.width,
    height: rect.height,
    scale: getAppScale(),
  };
}

export function windowMetrics(box, frameGrow = 0) {
  const scale = box.scale > 0 ? box.scale : 1;
  const frameWidth = box.width / scale;
  const frameHeight = box.height / scale;
  const grow = frameGrow > 0 ? frameGrow / scale : 0;
  const designWidth = frameWidth * 0.45 + grow;
  const designHeight = frameHeight * 0.48 + grow;
  return {
    scale,
    designWidth,
    designHeight,
    visualWidth: designWidth * scale,
    visualHeight: designHeight * scale,
  };
}

export function readWindowPos(key) {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "{}");
    return {
      leftRatio: Number.isFinite(parsed.leftRatio) ? parsed.leftRatio : 0.5,
      topRatio: Number.isFinite(parsed.topRatio) ? parsed.topRatio : 0.5,
    };
  } catch {
    return { leftRatio: 0.5, topRatio: 0.5 };
  }
}
